// src/components/home/EnrollmentCTASection.jsx
import React from 'react';
import styles from './EnrollmentCTASection.module.css';

const EnrollmentCTASection = ({ setIsPopupVisible }) => {
  return (
    <section className={styles.enrollmentCta}>
      <div className={styles.enrollmentContent}>
        <h2>Ready to Start Your Tech Journey?</h2>
        <p>Join Bspark today and take the first step towards a rewarding career in technology. Our admissions are open!</p>
        <button className={styles.ctaButton} onClick={() => setIsPopupVisible(true)}>
          Enroll Now
        </button>
      </div>
    </section>
  );
};

export default EnrollmentCTASection;
